<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h4 class="card-title">รายละเอียดการสั่งซื้อ</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <h6>เลขที่ใบสั่งซื้อ</h6>
            </div>
            <div class="col-md-4">{{ order.orderNo }}</div>
            <div class="col-md-2"><h6>ข้อมูลลูกค้า</h6></div>
            <div class="col-md-4"></div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <h6>วันที่สั่งซื้อ</h6>
            </div>
            <div class="col-md-4">{{ order.purchaseDate }}</div>
            <div class="col-md-2">
              <h6>ชื่อ - สกุล</h6>
            </div>
            <div class="col-md-4">{{ order.fullName }}</div>
            <div class="col-md-2">
              <h6>รูปแบบการชำระเงิน</h6>
            </div>
            <div class="col-md-4">{{ order.paymentMethodName }}</div>
            <div class="col-md-2">
              <h6>Line Id</h6>
            </div>
            <div class="col-md-4">{{ order.lineId || "-" }}</div>
            <div class="col-md-2">
              <h6>ธนาคาร</h6>
            </div>
            <div class="col-md-4">{{ order.bankName || "-" }}</div>
            <div class="col-md-2">
              <h6>Facebook</h6>
            </div>
            <div class="col-md-4">{{ order.facebook || "-" }}</div>
            <div class="col-md-2">
              <h6>วันที่ชำระเงิน</h6>
            </div>
            <div class="col-md-4">{{ order.paidDate || "-" }}</div>
            <div class="col-md-2">
              <h6>อีเมล</h6>
            </div>
            <div class="col-md-4">{{ order.email || "-" }}</div>
            <div class="col-md-2">
              <h6>สถานะ</h6>
            </div>
            <div class="col-md-4">{{ order.statusStr || "-" }}</div>
            <div class="col-md-2">
              <h6>โทร</h6>
            </div>
            <div class="col-md-4">{{ order.tel || "-" }}</div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h4 class="card-title">รายการสินค้า</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <n-button
                class="btn-info btn-round"
                @click="onExport"
                :disabled="onExporting"
              >
                Export to PDF
              </n-button>
            </div>
          </div>
          <a-table
            :columns="columns"
            :data-source="data"
            :loading="detailsLoaded"
            :scroll="{ x: 650 }"
          >
            <template #footer>
              <div class="row">
                <div class="col-md-9"></div>
                <div class="col-md-3" style="text-align: right">
                  <strong>จำนวนเงินรวมทั้งสิ้น (บาท) {{ total }} </strong>
                </div>
              </div>
            </template>
          </a-table>
          <!-- <br />
          <div class="row">
            <div class="col-md-12">
              <strong>หมายเหตุ</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p>หมายเลข PIN: xxxx-xxxx-xxxx</p>
            </div>
          </div> -->
          <div class="text-center">
            <n-button
              class="btn-outline-default btn-round"
              size="lg"
              @click="onBack"
            >
              กลับ
            </n-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import download from "downloadjs";
import moment from "moment";
import * as configuration from "../../middleware/configuration";
import * as orderservice from "../../services/order";

const columns = [
  {
    title: "No",
    dataIndex: "no",
    key: "no",
    width: 65,
  },
  {
    title: "รหัส",
    dataIndex: "packageId",
    key: "packageId",
    width: 70,
  },
  {
    title: "คำอธิบาย",
    dataIndex: "packageName",
    key: "packageName",
    width: 130,
  },
  {
    title: "จำนวน",
    dataIndex: "qty",
    align: "right",
    key: "qty",
  },
  {
    title: "ราคาต่อหน่วย",
    dataIndex: "price",
    align: "right",
    key: "price",
  },
  {
    title: "รวม",
    dataIndex: "total",
    align: "right",
    key: "total",
  },
];
export default {
  methods: {
    async getOrderDetails() {
      try {
        let id = this.$route.params.id;
        let res = await orderservice.getOrderDetails("order", id);
        let count = 1;
        let total = 0;
        res.data.orders.map((x) => {
          x.no = count++;
          total += x.price * x.qty;
        });
        res.data.purchaseDate = moment(res.data.purchaseDate).format(
          "DD/MM/YYYY HH:mm:ss"
        );
        this.total = total;
        this.order = res.data;
        this.data = res.data.orders;
      } catch (error) {
        console.log(error);
      } finally {
        this.gameLoaded = true;
      }
    },
    async getManageDetails() {
      try {
        let id = this.$route.params.id;
        let res = await orderservice.getOrderDetails("manage", id);
        let count = 1;
        let total = 0;
        res.data.orders.map((x) => {
          x.no = count++;
          total += x.price * x.qty;
        });
        res.data.purchaseDate = moment(res.data.purchaseDate).format(
          "DD/MM/YYYY HH:mm:ss"
        );
        this.total = total;
        this.order = res.data;
        this.data = res.data.orders;
      } catch (error) {
        console.log(error);
      } finally {
        this.gameLoaded = true;
      }
    },
    onBack() {
      this.$router.push(
        this.route === "Management Purchase Details"
          ? "/management/history"
          : "/purchase/history"
      );
    },
    async onExport() {
      this.onExporting = true;
      let id = this.$route.params.id;
      var options = {
        headers: { Uid: this.uid },
        responseType: "blob",
      };

      try {
        let res = await orderservice.exportOrder(id, options);
        const content = res.headers["content-type"];
        download(res.data, this.order.orderNo, content);
      } catch (error) {
        console.log(error);
      } finally {
        this.onExporting = false;
      }
    },
  },
  data() {
    return {
      onExporting: false,
      columns: columns,
      order: {},
      data: [],
      total: 0,
      uid: "",
      route: "",
      role: "",
      manage: false,
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  async beforeMount() {
    this.route = this.currentRouteName;
    this.uid = await configuration.getUid();
    let result = await configuration.getIdTokenResult();
    if (result) {
      if (this.route === "Management Purchase Details") {
        this.role = result.claims?.role || this.role;
        this.manage =
          this.role === "admin" ||
          this.role === "manager" ||
          this.role === "staff";
        if (
          this.role === "admin" ||
          this.role === "manager" ||
          this.role === "staff"
        ) {
          await this.getManageDetails();
        } else {
          await this.getOrderDetails();
        }
      } else {
        this.manage = false;
        await this.getOrderDetails();
      }
    }
  },
};
</script>

<style>
</style>